<template>
    <div class="h-auto">
        <v-card class="h-auto">
            <v-card-title class="bg-primary w-100">
                <div class="d-flex justify-content-between w-100">
                    <div class="text-white">
                        <h5 style="min-width: 400px; " v-if="mode === 'create'" class="ml-2">Création d'une offre</h5>
                        <h5 style="min-width: 400px; " v-else-if="mode === 'update'" class="ml-2">Modification d'une
                            offre
                        </h5>
                    </div>

                    <div class="text-right w-100">
                        <v-btn icon dark @click="cancel">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-card-title>

            <v-card-text class="pl-0 pb-0 h-auto pr-0">
                <div class="d-flex h-100">
                    <v-stepper @change="setModalCurrentStep" non-linear :value="modalCurrentStep"
                               class="h-auto offer-config config-stepper">
                        <v-stepper-header>
                            <v-stepper-step editable step="1">
                                <div class="d-flex">
                                    <v-icon class="mr-2">description</v-icon>
                                    <span class="mt-auto mb-auto">Description</span>
                                </div>
                            </v-stepper-step>

                            <v-stepper-step editable step="2">
                                <div class="d-flex">
                                    <v-icon class="mr-2">euro</v-icon>
                                    <span class="mt-auto mb-auto">Prix</span>
                                </div>
                            </v-stepper-step>

                            <v-stepper-step editable step="3">
                                <div class="d-flex">
                                    <v-icon class="mr-2">quiz</v-icon>
                                    <span class="mt-auto mb-auto">Questions associées</span>
                                </div>
                            </v-stepper-step>

                            <v-stepper-step editable step="4">
                                <div class="d-flex">
                                    <v-icon class="mr-2">settings</v-icon>
                                    <span class="mt-auto mb-auto">Configuration</span>
                                </div>
                            </v-stepper-step>

                            <div class="my-auto">
                                <v-btn class="default-button mx-auto d-flex mb-2 mt-2" @click="checkNameAndPrices">
                                    <v-icon class="mr-2">save</v-icon>
                                    Enregistrer & Quitter
                                </v-btn>
                            </div>

                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-text-field
                                  outlined
                                  label="Nom de l'offre"
                                  v-model="offer.label"
                                  hide-details
                                  class="mb-5"
                                  :class="{'input-error': submitted && (offer.label === null || offer.label === '') }"
                                ></v-text-field>

                                <ckeditor
                                  :editor="editor"
                                  v-model="offer.description"
                                ></ckeditor>
                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <div class="d-flex">
                                    <v-simple-table class="cadh-offer-table no-hover">
                                        <tbody>
                                        <tr>
                                            <td>
                                                Type
                                            </td>

                                            <td>
                                                <v-select
                                                  v-model="priceType"
                                                  @change="changePriceType"
                                                  outlined
                                                  :items="['Fixe', 'Au choix', 'Par unité']"
                                                  class="mb-2 cadh-config-price-input"
                                                  hide-details
                                                  :disabled="usedInCampaign && mode === 'update'"
                                                ></v-select>
                                            </td>

                                            <td>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <span class="mr-2 pt-6" v-if="priceType === 'Fixe'">Montant</span>
                                                <span class="mr-2 pt-6" v-else>Prix de base</span>
                                            </td>

                                            <td>
                                                <v-text-field
                                                  outlined
                                                  v-model="offer.price"
                                                  class="mb-2 cadh-config-price-input"
                                                  :class="{'input-error': submitted &&
                                                    (offer.price === null || offer.price === '')}"
                                                  hide-details
                                                  type="number"
                                                  suffix="€"
                                                  min="0"
                                                  max="100000"
                                                  :step="0.01"
                                                  @keydown="filterInput"
                                                  :disabled="usedInCampaign && mode === 'update'"
                                                ></v-text-field>
                                            </td>
                                        </tr>

                                        <tr v-if="priceType !== 'Fixe'">
                                            <td>
                                                Prix maximum
                                            </td>

                                            <td>
                                                <v-text-field
                                                  outlined
                                                  v-model="offer.max_price"
                                                  class="mb-2 cadh-config-price-input"
                                                  hide-details
                                                  type="number"
                                                  suffix="€"
                                                  min="0"
                                                  max="100000"
                                                  @keydown="filterInput"
                                                  :disabled="usedInCampaign && mode === 'update'"
                                                ></v-text-field>
                                            </td>

                                            <td>
                                                <v-tooltip right>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-on="on">help</v-icon>
                                                    </template>
                                                    <span>
                                        Vous pouvez définir un prix maximum que l'offre ne pourra pas dépasser.
                                                        Laissez à 0 sinon.
                                    </span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </v-simple-table>

                                    <div class="ml-auto">
                                        <v-menu bottom transition="slide-y-transition"
                                                v-if="priceType !== 'Fixe' && ((usedInCampaign && mode === 'create') || !usedInCampaign)">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn rounded icon v-on="on">
                                                    <v-icon>settings</v-icon>
                                                </v-btn>
                                            </template>

                                            <v-list>
                                                <v-list-item @click="addOfferParamByUnity"
                                                             v-if="priceType === 'Par unité'">
                                                    <v-list-item-title>
                                                        <v-icon class="custom-button-error">add</v-icon>
                                                        Ajouter un choix par unité
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="addOfferParamByChoice"
                                                             v-if="priceType === 'Au choix'">
                                                    <v-list-item-title>
                                                        <v-icon class="custom-button-error">add</v-icon>
                                                        Ajouter un type de choix supplémentaire
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </div>

                                <div v-if="priceType !== 'Fixe' && offer.params.length > 0"
                                     v-for="(param, index) in offer.params"
                                     class="p-2 d-flex">
                                    <div class="p-4 border">
                                        <v-text-field
                                          outlined
                                          placeholder="Intitulé"
                                          v-model="param.label"
                                          hide-details
                                          class="mb-2"
                                          :class="{'input-error': submitted &&
                                              (param.label === null || param.label === '')}"
                                        ></v-text-field>

                                        <div class="d-flex" v-if="priceType === 'Par unité'">
                                            <v-simple-table class="cadh-offer-table no-hover">
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        Prix par unité
                                                    </td>

                                                    <td>
                                                        <v-text-field
                                                          outlined
                                                          v-model="param.values[0].price"
                                                          class="mb-2 cadh-config-price-input"
                                                          :class="{'input-error': submitted &&
                                                            (param.values[0].price === null
                                                            || param.values[0].price === '') }"
                                                          hide-details
                                                          type="number"
                                                          min="0"
                                                          max="100000"
                                                          :step="0.01"
                                                          suffix="€"
                                                          @keydown="filterInput"
                                                          :disabled="usedInCampaign && mode === 'update'"
                                                        ></v-text-field>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        Nombre d'unités maximum
                                                    </td>

                                                    <td>
                                                        <v-text-field
                                                          outlined
                                                          v-model="param.max"
                                                          class="mb-2 cadh-config-price-input"
                                                          hide-details
                                                          suffix="unités"
                                                          type="number"
                                                        ></v-text-field>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>

                                        <v-simple-table class="cadh-offer-table no-hover"
                                                        v-if="priceType === 'Au choix'"
                                                        v-for="(value, indexValue) in param.values">
                                            <tbody>
                                            <tr>
                                                <td class="p-0">
                                                    <v-text-field
                                                      outlined
                                                      placeholder="Intitulé du choix"
                                                      v-model="value.label"
                                                      hide-details
                                                      class="mb-2"
                                                      :class="{'input-error': submitted &&
                                              (value.label === null || value.label === '')}"
                                                    ></v-text-field>
                                                </td>

                                                <td>
                                                    <v-text-field
                                                      outlined
                                                      placeholder="Montant du choix"
                                                      v-model="value.price"
                                                      :class="{'input-error': submitted &&
                                              (value.price === null || value.price === '')}"
                                                      hide-details
                                                      type="number"
                                                      class="mb-2 mx-2"
                                                      suffix="€"
                                                      min="0"
                                                      max="100000"
                                                      :step="0.01"
                                                      @keydown="filterInput"
                                                      :disabled="usedInCampaign && mode === 'update'"
                                                    ></v-text-field>
                                                </td>

                                                <td>
                                                    <button class="ml-2 cadh-config-button-icon"
                                                            @click="deleteValue(index, indexValue)"
                                                            v-if="!(usedInCampaign && mode === 'update')"
                                                            :disabled="indexValue === 0">
                                                        <v-icon :color="indexValue === 0 ? 'gray' : 'red'">
                                                            delete
                                                        </v-icon>
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </v-simple-table>

                                        <div class="w-100 text-center">
                                            <button class="text-none default-button mt-5"
                                                    v-if="((usedInCampaign && mode === 'create') || !usedInCampaign) && priceType === 'Au choix'"
                                                    @click="addValue(index)">
                                                <v-icon class="mr-1" color="white" dense>
                                                    add
                                                </v-icon>
                                                Ajouter un choix
                                            </button>
                                        </div>
                                    </div>

                                    <button class="ml-2 cadh-config-button-icon"
                                            @click="deleteParam(index)"
                                            v-if="!(usedInCampaign && mode === 'update')">
                                        <v-icon color="red">delete
                                        </v-icon>
                                    </button>
                                </div>

                            </v-stepper-content>

                            <v-stepper-content step="3">
                                <v-alert type="info"
                                         text
                                         class="container m-0 mr-3">
                                    Vous pouvez choisir d'afficher l'offre en fonction des réponses aux questions.
                                    L'offre sera visible pour les réponses cochées ci-après.
                                </v-alert>

                                <div v-if="criteriaFamilies.length === 0" class="mt-8 text-center">
                                    <span>Vous n'avez configuré aucune question</span>
                                </div>

                                <div v-else v-for="family in criteriaFamilies" class="w-100 mx-2 my-4">
                                    <div class="d-flex justify-content-between">
                                <span>
                                    {{ family.label }}
                                </span>

                                        <div class="d-flex">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="selectAllCriterias(family, offer)" class="mr-2"
                                                            v-on="on">
                                                        <v-icon small class="select-button">done_all</v-icon>
                                                    </button>
                                                </template>
                                                <span>Sélectionner tout</span>
                                            </v-tooltip>

                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="unselectAllCriterias(family, offer)" class="mr-2"
                                                            v-on="on">
                                                        <v-icon small class="select-button">remove_done</v-icon>
                                                    </button>
                                                </template>
                                                <span>Désélectionner tout</span>
                                            </v-tooltip>
                                        </div>
                                    </div>

                                    <v-select
                                      outlined
                                      chips
                                      :items="family.criterias"
                                      v-model="offer.criterias"
                                      item-text="label"
                                      item-value="id"
                                      return-object
                                      hide-details
                                      deletable-chips
                                      multiple
                                      class="mr-2"
                                    ></v-select>
                                </div>
                            </v-stepper-content>

                            <v-stepper-content step="4">
                                <v-checkbox
                                  label="Offre sélectionnable une fois maximum"
                                  v-model="offer.multiple"
                                  v-if="!(usedInCampaign && mode === 'update')"
                                  hide-details
                                  class="mb-2"
                                ></v-checkbox>

                                <div v-else-if="usedInCampaign && mode === 'update' && !offer.multiple">
                                    <v-icon class="mr-2">check_box_outline_blank</v-icon>
                                    <span class="fake-disable-checkbox-label">
                                        Offre sélectionnable une fois maximum
                                    </span>
                                </div>

                                <div v-else>
                                    <v-icon class="mr-2" color="primary">check_box</v-icon>
                                    <span class="fake-disable-checkbox-label">
                                        Offre sélectionnable une fois maximum
                                    </span>
                                </div>

                                <v-checkbox
                                  label="Masquer l'offre"
                                  v-model="offer.hidden"
                                  hide-details
                                  class="mb-2"
                                ></v-checkbox>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>

                    <div class="example-offer overflow-offer d-flex flex-column">
                        <h2 class="text-center my-5">Prévisualisation</h2>
                        <v-card class="cadh-offer-card mt-5 mx-auto mb-5" width="340px">
                            <v-app-bar dark color="#219eb9" class="offer-toolbar">
                                <div class="d-flex justify-content-between offer-title w-100">
                                    <div>{{ offerName }}</div>
                                </div>

                            </v-app-bar>

                            <v-card-text style="font-size: 16px">
                                <div v-if="offer.description !== null" style="margin-bottom: 30px">
                                    <div v-html="offer.description"></div>
                                    <hr>
                                </div>

                                <div v-if="priceType !== 'Fixe' && offer.params.length > 0" class="mb-5">
                                    <div v-for="param in offer.params">
                                        <label class="custom-label">{{ param.label }}</label>
                                        <v-select :items="param.values"
                                                  v-if="param.field_type === 'select'"
                                                  item-text="label"
                                                  return-object
                                                  hide-details
                                                  class="mb-5"
                                                  v-model="param.selectedValue"
                                                  outlined>
                                        </v-select>

                                        <v-text-field class="w-100 mb-5"
                                                      v-else-if="param.field_type === 'quantifiable'"
                                                      item-text="label"
                                                      return-object
                                                      hide-details
                                                      v-model="param.quantity"
                                                      min="0"
                                                      style="padding-top: 0 !important;"
                                                      :max="param.max"
                                                      type="number"
                                                      outlined>
                                        </v-text-field>
                                    </div>
                                    <hr>
                                </div>

                                <div class="d-flex justify-content-between">
                                    <div class="text-center mt-auto mb-auto">
                                <span v-if="getOfferPrice(offer) !== 0">
                                    {{ formatPrice(getOfferPrice(offer)) }}&nbsp;€
                                </span>

                                    </div>

                                    <v-text-field class="offer-quantity shrink"
                                                  v-if="!offer.multiple || offer.quantity !== 1"
                                                  item-text="label"
                                                  return-object
                                                  type="number"
                                                  style="padding-top: 0 !important;"
                                                  min="1"
                                                  label="Quantité"
                                                  disabled
                                                  hide-details
                                                  v-model="offer.quantity"
                                                  outlined>
                                    </v-text-field>

                                    <v-btn class="cadh-offer-button text-none mt-auto mb-auto">
                                        Ajouter
                                    </v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                </div>
            </v-card-text>
        </v-card>

        <v-dialog ref="dialog" v-model="confirmExitModal" width="400px">
            <v-card>
                <v-toolbar dark class="bg-primary" dense flat>
                    <v-toolbar-title class="white--text">
                        Fermer sans enregistrer ?
                    </v-toolbar-title>
                </v-toolbar>

                <v-card-text class="pa-4">
                    Si vous quittez sans enregistrer, vos modifications seront perdues.
                </v-card-text>

                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click="confirmExitModal = false" class="default-button custom-button-primary">
                        Revenir à mon offre
                    </v-btn>
                    <v-btn @click="confirmExit">
                        Oui
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import ClassicEditor from "../../../plugins/ckeditor"
import Confirm from "../../tools/Confirm.vue"
import hash from "object-hash"
import _ from "lodash"

export default {
    name: "CreateOfferModal",
    props: ["offer", "mode", "priceType"],
    data() {
        return {
            dialog: false,
            resolve: null,
            submitted: false,
            editor: ClassicEditor,
            hashOffer: null,
            isDirty: false,
            confirmExitModal: false,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setModalCurrentStep", "setOfferModal"]),
        open() {
            this.dialog = true

            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        cancel() {
            if (this.isDirty) {
                this.confirmExitModal = true
            } else {
                this.hashOffer = null
                this.isDirty = false
                this.setOfferModal(false)
            }
        },
        confirmExit() {
            this.hashOffer = null
            this.isDirty = false
            this.confirmExitModal = false
            this.setOfferModal(false)
        },
        addOfferParamByUnity() {
            let newParam = {
                "field_type": "quantifiable",
                "label": "",
                "max": null,
                "values": [
                    {
                        "price": 0,
                        "order": 1,
                    },
                ],
                "external_id": this.offer.params.length + 1,
                "order": this.offer.params.length + 1,
            }
            this.offer.params.push(newParam)
        },
        addOfferParamByChoice() {
            let newParam = {
                "field_type": "select",
                "label": "",
                "values": [
                    {
                        "price": 0,
                        "label": "",
                        "order": 1,
                    },
                ],
                "external_id": this.offer.params.length + 1,
                "order": this.offer.params.length + 1,
            }
            this.offer.params.push(newParam)
        },
        addValue(index) {
            let value = {
                "price": 0,
                "label": "",
                "order": this.offer.params[index].values.length + 1,
            }

            this.offer.params[index].values.push(value)
        },
        deleteValue(index, indexValue) {
            this.offer.params[index].values.splice(indexValue, 1)
        },
        deleteParam(index) {
            this.offer.params.splice(index, 1)

            if (this.offer.params.length === 0) {
                this.priceType = "Fixe"
            }
        },
        getOfferPrice(offer) {
            let price = parseFloat(offer.price)
            let paramsPrice = 0

            if (offer.params.length) {
                if (offer.operation_type === "A") {
                    offer.params.forEach(param => {
                        paramsPrice += this.getParamPrice(param)
                    })
                } else {
                    paramsPrice = 1

                    offer.params.forEach(param => {
                        paramsPrice *= this.getParamPrice(param)
                    })

                    paramsPrice = paramsPrice * 100
                    paramsPrice = paramsPrice * 100
                }
            }

            price += parseFloat(paramsPrice)

            if (price > parseFloat(offer.max_price) && parseFloat(offer.max_price) !== 0) {
                price = offer.max_price
            }

            return parseFloat(price).toFixed(2)
        },
        getParamPrice(param) {
            let price = 0

            if (param.selectedValue !== undefined && param.selectedValue !== null) {
                price = param.selectedValue.price
            } else if (param.quantity !== null && param.quantity > 0) {
                price = param.values[0].price * param.quantity
            }

            return price
        },
        updateOffer() {
            let criteriasIds = this.offer.criterias && this.offer.criterias.length > 0 ?
              this.offer.criterias.map(function(criteria) {
                  return criteria.id
              }) : []

            if (this.offer.params.length > 0) {
                this.offer.params.forEach(param => param.values.map((value) => value.price = Math.round(value.price * 100)))
            }

            let payload = {
                "offerId": this.offer.id,
                "offerPrice": Math.round(this.offer.price * 100),
                "offerLabel": this.offer.label,
                "multiple": this.offer.multiple,
                "order": this.offer.order,
                "hidden": this.offer.hidden,
                "description": this.offer.description,
                "maxPrice": this.offer.max_price !== null && this.offer.max_price !== "" ?
                  Math.round(this.offer.max_price * 100) : 0,
                "operationType": this.offer.operation_type,
                "params": this.priceType === "Fixe" ? [] : this.offer.params,
                "criteriasIds": criteriasIds,
            }

            this.hashOffer = null
            this.isDirty = false
            this.setOfferModal(false)

            this.$store.dispatch("cadhConfig/updateOffer", payload)
        },
        createOffer() {
            let criteriasIds = this.offer.criterias.length > 0 ?
              this.offer.criterias.map(function(criteria) {
                  return criteria.id
              }) : []

            if (this.offer.params.length > 0) {
                this.offer.params.forEach(param => param.values.map((value) => value.price = Math.round(value.price * 100)))
            }

            let payload = {
                "configId": this.cadhConfig.id,
                "offerPrice": Math.round(this.offer.price * 100),
                "offerLabel": this.offer.label,
                "multiple": this.offer.multiple,
                "order": this.offer.order,
                "hidden": this.offer.hidden,
                "description": this.offer.description,
                "maxPrice": this.offer.max_price !== null && this.offer.max_price !== "" ?
                  Math.round(this.offer.max_price * 100) : 0,
                "operationType": this.offer.operation_type,
                "params": this.offer.params,
                "criteriasIds": criteriasIds,
            }

            this.$global.loading = true

            this.hashOffer = null
            this.isDirty = false
            this.setOfferModal(false)

            this.$store.dispatch("cadhConfig/createOffer", payload)

            this.$global.loading = false
        },
        changePriceType() {
            if (this.priceType === "Au choix" && this.offer.params.length === 0) {
                this.addOfferParamByChoice()
            } else if (this.priceType === "Par unité" && this.offer.params.length === 0) {
                this.addOfferParamByUnity()
            }

            if (this.priceType === "Par unité" && this.offer.params.length > 0) {
                this.offer.params.forEach(param => {
                    let splicedValues = param.values.slice(0, 1)

                    param.field_type = "quantifiable"
                    param.values = splicedValues
                })
            } else if (this.priceType === "Au choix" && this.offer.params.length > 0) {
                this.offer.params.forEach(param => {
                    param.field_type = "select"
                })
            }

            if(this.priceType === 'Fixe') {
                this.offer.max_price = 0
                this.offer.params = []
            }
        },
        checkNameAndPrices() {
            this.submitted = true
            let checkName = this.offer.label !== null && this.offer.label !== ""

            let checkPrice = this.offer.price !== null && this.offer.price !== ""

            let checkParamName = true

            let checkValueName = true

            if (checkPrice && this.offer.params.length > 0) {

                this.offer.params.forEach(param => {
                    checkParamName = param.label !== null && param.label !== ""

                    param.values.forEach(value => {
                        if (value.price === null || value.price === "") {
                            checkPrice = false
                        }

                        if (value.label === null || value.label === "") {
                            checkValueName = false
                        }
                    })
                })
            }

            if (!checkName) {
                this.setModalCurrentStep("1")
            } else if (!checkPrice || !checkParamName || !checkValueName) {
                this.setModalCurrentStep("2")
            }

            if (checkName && checkPrice && checkValueName && checkParamName && this.mode === "create") {
                this.submitted = false
                this.createOffer()
            } else if (checkName && checkPrice && checkValueName && checkParamName && this.mode === "update") {
                this.submitted = false
                this.updateOffer()
            }
        },
        filterInput(event) {
            const invalidChars = ["e", "E", "+", "-"]

            if (invalidChars.includes(event.key)) {
                event.preventDefault()
            }
        },
        selectAllCriterias(family, offer) {
            family.criterias.forEach(criteria => {
                let offerCriteriasids = offer.criterias.map(crit => crit.id)

                if (!offerCriteriasids.includes(criteria.id)) {
                    offer.criterias.push(criteria)
                }
            })
        },
        unselectAllCriterias(family, offer) {
            family.criterias.forEach(criteria => {
                let offerCriteriasids = offer.criterias.map(crit => crit.id)

                if (offerCriteriasids.includes(criteria.id)) {
                    let index = offerCriteriasids.indexOf(criteria.id)

                    if (index > -1) {
                        offer.criterias.splice(index, 1)
                    }
                }
            })
        },
        formatPrice(price) {
            return price.toString().replace('.', ',')
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "usedInCampaign", "modalCurrentStep", "criteriaFamilies"]),
        offerName() {
            return this.offer.label !== "" && this.offer.label !== null ? this.offer.label : "Nom de l'offre"
        },
    },
    watch: {
        offer: {
            handler: _.debounce(function() {
                if (this.hashOffer === null) {
                    this.hashOffer = hash(this.offer)
                }

                this.isDirty = this.hashOffer !== hash(this.offer)
            }, 500),
            deep: true,
        },
    },
}
</script>